export const initialState = {
  patients: []
};
